import deepCleaner from 'deep-cleaner';
import mapJson from 'jsonpath-mapper';
import { EntriesResult, NodesResult } from '~/models/Operations';

export const mapMigrateEnvironmentResponse = (
  input: EntriesResult & NodesResult & any
) =>
  // deepCleaner will remove all undefined and null keys
  // running deepCleaner again will clean up all empty objects
  // for a cleaner output
  deepCleaner(
    deepCleaner(
      mapJson(input, {
        committed: () => !input.isPreview,
        query: ['entries.query', 'payload.query'],
        zenQL: ['entries.zenQL', 'payload.zenQL'],
        errors: 'errors',
        nodes: {
          source: input.isPreview ? 'nodes.nodes' : () => undefined,
          migrateResult: 'nodes.nodesResult',
          existing: 'nodes.existing',
        },
        entries: {
          migrateResult: 'entries.migrateResult',
          source: input.isPreview ? 'entries.entries' : () => undefined,
          existing: 'entries.existing',
        },
        models: {
          contentTypes: 'models.contentTypes',
          components: 'models.components',
        },
      })
    )
  );
